// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM10.0039 11V13.0039H8V11H10.0039ZM15.3761 18.4142L12.7283 15.7665L11.1163 17.3794L10.4645 16.5951L9.76475 17.2717L8.62222 18.4142L7.20801 17L8.36237 15.8456L10.6243 13.6583L11.2524 14.414L12.7279 12.9376L16.7903 17L15.3761 18.4142Z"}}]};

const FileImageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-image-filled',
    ref,
    icon: element,
  },
));

FileImageFilledIcon.displayName = 'FileImageFilledIcon';

export default FileImageFilledIcon;
